import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { Space } from "../../entities/space";
import { IPricing } from "@/app/domain";

export class SubtotalCalculationStrategy extends CalculationStrategy {
    public calculate(
        spaces: Space[],
        [multiplicator = 1, discountedExtraTotal],
    ): PriceResult {
        return {
            price:
                this.calculateComponentsPriceForType(
                    spaces,
                    CostDealType,
                    discountedExtraTotal,
                ) * multiplicator,
            priceB2C:
                this.calculateComponentsPriceForType(
                    spaces,
                    B2CDealType,
                    discountedExtraTotal,
                ) * multiplicator,
            priceB2B:
                this.calculateComponentsPriceForType(
                    spaces,
                    B2BDealType,
                    discountedExtraTotal,
                ) * multiplicator,
        };
    }

    private calculateComponentsPriceForType(
        spaces: Space[],
        dealType: string,
        discountedExtraTotal: IPricing,
    ) {
        const sumDiscountedExtra = discountedExtraTotal?.getSystemPrice(dealType).getValue() || 0;
        const subtotal = spaces.reduce((total, space) => {
            const sum = space.sum.getSystemPrice(dealType).getValue();

            return total + sum;
        }, 0);

        return subtotal + sumDiscountedExtra;
    }
}
